import React from 'react';
import { Alert } from '@material-ui/lab';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { makeStyles } from '@material-ui/core/styles';

interface ErrorMessageProps {
    errorMessage: string
};

const useStyles = makeStyles((theme) => ({
    alertRoot: {
        marginTop: 24,
        padding:"6px 12px",
    },
}));

const ErrorMessage: React.FC<ErrorMessageProps> = ({errorMessage}) =>{
    const classes = useStyles();
    return (
        <div>
            <Alert variant="filled"
                icon={<ReportProblemOutlinedIcon />}
                severity="error"
                classes={{ root: classes.alertRoot }}
                style={{ display: 'flex'}}>
                {errorMessage}
            </Alert>
        </div>
    );
}

export default ErrorMessage;